// Auth API — обёртки для Magic-link login flow
// Все запросы идут на /api/auth/* через прокси Vite (dev) или nginx (prod)

const BOT_NAME_MAX = 'id510107251374_bot' // совпадает с MAX_BOT_ID в land

export interface StartLoginResponse {
  loginToken: string
  expiresInSec: number
}

export interface CheckLoginResponse {
  status: 'pending' | 'success'
}

export interface MeResponse {
  maxAdminID: string
  expiresAt: string
}

const API_BASE = ''

async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    credentials: 'include', // отправляем/принимаем cookies
    headers: {
      'Content-Type': 'application/json',
      ...init?.headers,
    },
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: `HTTP ${res.status}` }))
    throw Object.assign(new Error(err.error || `HTTP ${res.status}`), {
      status: res.status,
      body: err,
    })
  }
  return res.json()
}

export async function startLogin(): Promise<StartLoginResponse> {
  return api<StartLoginResponse>('/api/auth/start-login', { method: 'POST' })
}

export async function checkLogin(token: string): Promise<CheckLoginResponse> {
  return api<CheckLoginResponse>(`/api/auth/check-login?token=${encodeURIComponent(token)}`)
}

export async function getMe(): Promise<MeResponse> {
  return api<MeResponse>('/api/auth/me')
}

export async function logout(): Promise<void> {
  await api('/api/auth/logout', { method: 'POST' })
}

export function buildMaxAuthUrl(loginToken: string): string {
  return `https://max.ru/${BOT_NAME_MAX}?startapp=auth_login_${loginToken}`
}
